import React, { Component } from 'react';
import classNames from 'classnames';
import './filtered-chains.scss';

class FilteredChains extends Component {
    
    total(arr, key) {
        if (!arr) return null

        return arr.reduce((a, b) => a + b[key], 0);
    }

    calcPercent(units, total) {
        return (units / total) * 100;
    }

    orderByUnits(all) {

        if (!all) return null;

        return all.sort((a, b) => b.numberOfUnits - a.numberOfUnits);
    }

    orderByTurnover(all) {
        if (!all) return null;

        return all.sort((a, b) => b.totalTurnover - a.totalTurnover);
    }

    getChainGroups() {
        const { filterSelection } = this.props;
        
        if (!filterSelection) return [];

        const result = [];

        filterSelection.selectedChains.reduce((res, value) => {
          if (!res[value.chainGroupName]) {
            res[value.chainGroupName] = { chainGroupName: value.chainGroupName, numberOfUnits: 0, totalTurnover: 0 };
            result.push(res[value.chainGroupName])
          }
          res[value.chainGroupName].numberOfUnits += value.numberOfUnits;
          res[value.chainGroupName].totalTurnover += value.totalTurnover;
          
          return res;
        }, {});

        return result;

    }
    
    getBgColor(index) {
        const colors = [
            {
                color: '#c34353',
                name: 'dusty-red'
            },
            { 
                color: '#f2b146',
                name: 'butterscotch'
            }, 
            { 
                color: '#83b69c',
                name: 'pale-teal'
            },
            {
                color: '#0b3358',
                name: 'dabas-blue'
            }, 
            {
                color: '#726454',
                name: 'greyish-brown'
            },
            {
                color: '#79bafa',
                name: 'sky-blue'
            }, 
            {
                color: '#222',
                name: 'text-black'
            }];
        const colorIndex = index % 7;
        return colors[colorIndex];
    }
    
    render() {
        
        const chainGroupsOrdered = this.orderByUnits(this.getChainGroups());
        const chainGroupsOrderedByTurnover = this.orderByTurnover(this.getChainGroups());


        return (
            <section className="filtered-chains">
                {this.props.type !== 'foodservice' &&
                    <div className="filtered-chains__top">
                        <div className="details__container">
                            <div className="details__container-inner">
                            
                                <h2 className="filtered-chains__heading">Kedjor</h2>

                                <div className="filtered-chains__graph-container">
                                    
                                    <div className="filtered-chains__graph">
                                        <h3 className="filtered-chains__graph-heading">Antal butiker</h3>
                                        <span className="filtered-chains__graph-sub-heading">Totalt antal butiker: {this.total(chainGroupsOrdered, 'numberOfUnits').toLocaleString('sv')} st</span>
                                        <div className="filtered-chains__graph-bar">
                                            {chainGroupsOrdered && chainGroupsOrdered.map((chain, index) => {
                                                return (
                                                    <div className="filtered-chains__graph-bar-item" style={{backgroundColor: this.getBgColor(index).color ,width:`${this.calcPercent(chain.numberOfUnits, this.total(chainGroupsOrdered, 'numberOfUnits'))}%`}}>
                                                        {this.calcPercent(chain.numberOfUnits, this.total(chainGroupsOrdered, 'numberOfUnits')).toFixed(1)}%
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="filtered-chains__graph-bar-text">
                                            {chainGroupsOrdered && chainGroupsOrdered.map((chain, index) => {
                                                return (
                                                    <span className={classNames({
                                                        'filtered-chains__graph-bar-text-item': true,
                                                        [`filtered-chains__graph-bar-text-item--${this.getBgColor(index).name}`]: true 
                                                    })}>
                                                        {chain.chainGroupName}
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <div className="filtered-chains__graph">
                                        <h3 className="filtered-chains__graph-heading">Omsättning</h3>
                                        <span className="filtered-chains__graph-sub-heading">Totalt omsättning: {this.total(chainGroupsOrdered, 'totalTurnover').toLocaleString('sv')} kkr</span>
                                        <div className="filtered-chains__graph-bar">
                                            {chainGroupsOrderedByTurnover && chainGroupsOrderedByTurnover.map((chain, index) => {
                                                return (
                                                    <div className="filtered-chains__graph-bar-item" style={{backgroundColor: this.getBgColor(index).color ,width:`${this.calcPercent(chain.totalTurnover, this.total(chainGroupsOrdered, 'totalTurnover'))}%`}}>
                                                        {this.calcPercent(chain.totalTurnover, this.total(chainGroupsOrdered, 'totalTurnover')).toFixed(1)}%
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="filtered-chains__graph-bar-text">
                                            {chainGroupsOrdered && chainGroupsOrdered.map((chain, index) => {
                                                return (
                                                    <span className={classNames({
                                                        'filtered-chains__graph-bar-text-item': true,
                                                        [`filtered-chains__graph-bar-text-item--${this.getBgColor(index).name}`]: true 
                                                    })}>
                                                        {chain.chainGroupName}
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                
                <div className="filtered-chains__units">
                    <div className="details__container">
                        <div className="details__container-inner details__container-inner--no-padding">
                            {this.props.type === 'foodservice' &&
                                <h2 className="filtered-chains__heading">Kedjor</h2>
                            }
                            <div className="details__table-wrapper">
                                <table className="table table--striped table--num table--border-bottom table--tight">
                                    <thead>
                                        <tr>
                                            <th className="table__text">KEDJA</th>
                                            <th>ANTAL</th>
                                            {this.props.type !== 'foodservice' &&
                                                <>
                                                    <th>OMSÄTTNING <span className="table__light-header">(KKR)</span></th>
                                                    <th>SÄLJYTA <span className="table__light-header">(m2)</span></th>
                                                </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.orderByUnits(this.props.filterSelection.selectedChains).map(unit => {
                                            return (
                                                <tr>
                                                    <td className="table__text">{unit.name}</td>
                                                    <td>{unit.numberOfUnits.toLocaleString('sv')}</td>
                                                    {this.props.type !== 'foodservice' &&
                                                        <>
                                                            <td>{unit.totalTurnover.toLocaleString('sv')}</td>
                                                            <td>{unit.totalRetailArea.toLocaleString('sv')}</td>
                                                        </>
                                                   }
                                                </tr>
                                            );
                                        })}
                                        <tr className="tfoot">
                                            <td className="table__text">Totalt</td>
                                            <td>{this.total(this.props.filterSelection.selectedChains, 'numberOfUnits').toLocaleString('sv')} st</td>
                                            {this.props.type !== 'foodservice' &&
                                                <>
                                                    <td>{this.total(this.props.filterSelection.selectedChains, 'totalTurnover').toLocaleString('sv')} kkr</td>
                                                    <td>{this.total(this.props.filterSelection.selectedChains, 'totalRetailArea').toLocaleString('sv')} m2</td>

                                                </>
                                            }
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
};

export default FilteredChains;